import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM4 20H20V4H4V20ZM18.4072 10.2041L15.2236 11.0254L17.0557 18.2344L10.6406 19.8945L8.80957 12.6846L5.62598 13.5068L4.07715 7.41016L16.8574 4.10547L18.4072 10.2041ZM6.50488 8.84668L7.06934 11.0684L10.2549 10.2461L12.084 17.4551L14.626 16.7969L12.7939 9.58789L15.9785 8.76562L15.4141 6.54395L6.50488 8.84668Z"}}]};

const LogoTapd = Vue.extend<IconProps>({
  name: 'LogoTapdIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-tapd',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoTapd;
